import { Text, Title2, WasabiButton } from '@kk/ui';
import { useEffect, useState } from 'react';

import { useClients, useSession } from '@/auth/SessionProvider';
import { deck } from '@/copy/deck';
import { CLUBS_URL } from '@/lib/host';
import { SignInShell } from '@/screens/SignInShell';

/**
 * **SIGNED IN, BUT NOT ON A KIDDIE KREDIT TEAM ACCOUNT, ON THE ADMIN ADDRESS** (§8.1; copy ruled by Evan
 * 2026-09-23, COPY_DECK "Not a Kiddie Kredit team account, on admin.kiddiekredit.com").
 *
 * **Two ways out, because the reader is one of two people.** Club staff who followed the wrong link go to
 * Clubs; one of ours signed in on the wrong Google account signs out. A single action would strand whichever
 * of them it was not written for.
 *
 * **It names the address they are signed in as**, which is what somebody holding two accounts actually needs:
 * not "are you allowed" but "which one am I in". O00c (2026-09-26): an address with no invite and no role gets this
 * card on the admin — also when the sign-in itself was refused for being staff of nothing, so the address comes from
 * the auth client when there is no session to read it from.
 */
export function NotStaffHere() {
  const { session } = useSession();
  const { auth } = useClients();
  const [signedInAs, setSignedInAs] = useState<string | null>(null);
  useEffect(() => {
    if (!session) void auth.currentEmail().then(setSignedInAs);
  }, [auth, session]);
  const email = session?.user.email ?? session?.user.sub ?? signedInAs ?? '';
  return (
    <SignInShell>
      <div className="stack" data-testid="not-kk-staff">
        <Title2 tone="ink">{deck.states.notKkStaff.title}</Title2>
        <Text variant="bodySm" tone="slate" testID="not-kk-staff-body">
          {deck.states.notKkStaff.body(email)}
        </Text>
        <a className="wasabi-link" href={CLUBS_URL} data-testid="to-clubs">
          <Text variant="button" tone="ink">
            {deck.states.notKkStaff.toClubs}
          </Text>
        </a>
        <WasabiButton
          label={deck.states.notKkStaff.signOut}
          variant="text"
          textSize="sm"
          fullWidth={false}
          onPress={() => void auth.signOut()}
          testID="sign-out"
        />
      </div>
    </SignInShell>
  );
}
